var UserAgentService = {
  /**
   * Detects if the client is mobile based on the unreliable User Agent String
   * Uses a Regex from https://gist.github.com/dalethedeveloper/1503252 which should detect even obscure mobile user agents
   * @return {Boolean} true if the current device has a known mobile User Agent String
   */
  isMobile: function() {
    return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(navigator.userAgent);
  },
  isIE9: function() {
    return document.all && !window.atob;
  }
};

module.exports = UserAgentService;
